import Vue from 'vue'

import ElementUI from 'element-ui'
import 'element-theme-chalk'

import AsyncValidator from 'async-validator'

import Notifications from 'vue-notification'

import { getModule } from '@/modules/store'
import ConfigStore from "@/modules/config/store/ConfigStore"

import './assets/v3/css/main.styl'
import './themes/cv.styl'
import '../static/fonts/styles.css'
import '../static/icon-fonts/style.css'

import ErrorReporting from '@/utils/ErrorReporting'
ErrorReporting.init()

import PortalVue from 'portal-vue'
Vue.use(PortalVue)

Vue.config.productionTip = false

Vue.use(ElementUI)

// const globalVars = {}
// Object.keys(process.env).forEach(key => {
//     globalVars[key] = process.env[key]
// })
// window.globalVars = globalVars
// console.log('globalVars', globalVars, window.globalVars)

Vue.prototype.$serverAdminUrl = process.env.VUE_APP_ADMIN_URL
Vue.prototype.$serverRootUrl = process.env.VUE_APP_ROOT_URL

Vue.prototype.$processUrl = function (url) {
    console.log('processUrl', url)
  if (!url) return url
  const urlToTestAgainst = url.toLowerCase()
  if (urlToTestAgainst.indexOf(this.$serverAdminUrl) >= 0 || urlToTestAgainst.indexOf(this.$serverRootUrl) >= 0) return url
  url = url.replace(/\\/g, '/')
  let a = ['static/']
  let pre = Vue.prototype.$serverRootUrl

  a.some(item => {
    if (url.indexOf(item) >= 0) {
      pre = Vue.prototype.$serverAdminUrl
      return true
    }
    return false
  })

  if (pre && pre.charAt(pre.length - 1) === '/') pre = pre.substring(0, pre.length - 1)
  if (url.charAt(0) !== '/') url = '/' + url

  return pre + url
}

Vue.prototype.$getTemplateFileUrl = function (templateId, useProcessUrl = true) {
  const configStore = getModule(ConfigStore)
//   const url = '/GetFile.aspx?ft=DiplomaTemplate&fp=UsersFiles/AcademicDiplomaTemplates/' + templateId + '.pdf&DiplomaTemplateId=' + templateId + '&Token=' + configStore.userToken
  const url = '/GetFile.aspx?ft=DiplomaTemplate&fp=UsersFiles/AcademicDiplomaTemplates/' + templateId + '.pdf&DiplomaTemplateId=' + templateId
  // const url = '/GetFile.aspx?ft=DiplomaTemplate&fp=UsersFiles/AcademicDiplomaTemplates/' + templateId + '.pdf&DiplomaTemplateId=' + templateId + '&Token=' + restApi.serviceInfo.Token
  return useProcessUrl ? this.$processUrl(url) : url
}

Vue.prototype.$getTemplatePreviewUrl = function (templateId, useProcessUrl = true, useThumb = false) {
  const configStore = getModule(ConfigStore)
//   const url = '/GetFile.aspx?ft=DiplomaTemplate&fp=UsersFiles/AcademicDiplomaTemplates/Preview' + templateId + (useThumb ? '_thumb' : '') + '.jpg&DiplomaTemplateId=' + templateId + '&Token=' + configStore.userToken + '&cache=' + Date.now()
  const url = '/GetFile.aspx?ft=DiplomaTemplate&fp=UsersFiles/AcademicDiplomaTemplates/Preview' + templateId + (useThumb ? '_thumb' : '') + '.jpg&DiplomaTemplateId=' + templateId + '&cache=' + Date.now()
  // const url = '/GetFile.aspx?ft=DiplomaTemplate&fp=UsersFiles/AcademicDiplomaTemplates/Preview' + templateId + (useThumb ? '_thumb' : '') + '.jpg&DiplomaTemplateId=' + templateId + '&Token=' + restApi.serviceInfo.Token + '&cache=' + Date.now()
  return useProcessUrl ? this.$processUrl(url) : url
}

AsyncValidator.prototype.messages = function (messages) {
  const i18n = getAppInstance().getModuleByType(LocalizationModule).i18n
  console.log('getting validator messages', i18n.locale, messages, i18n.messages[i18n.locale].validator)
  return i18n.messages[i18n.locale].validator
}

Vue.prototype.$reportError = function (error) {
  ErrorReporting.captureException(error)
}

Vue.use(Notifications)
Vue.prototype.$showNotification = function (messages, type = 'info', title = '', options = null) {
    let a = []

    console.log('$showNotification', messages, Array.isArray(messages), messages instanceof Array)

    if (messages instanceof Array) {
        a = messages
    } else {
        a.push(messages)
    }

    if (!title) title = this.$t('commons.notifications.' + type)
    if (!options) options = {
        duration: 2500
    }

    a.forEach(msg => {
        let data = {
            group: 'main',
            title: title,
            text: msg,
            type: type,
            ...options
        }
        console.log('notify', data)
        this.$notify(data)
    })
}

console.log('starting app install')

import ConfigModule from './modules/config' // eslint-disable-line import/first
import LocalizationModule from './modules/localization' // eslint-disable-line import/first
import EventBusModule from './modules/eventbus' // eslint-disable-line import/first
import LocalStorageModule from './modules/local-storage' // eslint-disable-line import/first
import LocalRouterModule from './modules/local-router' // eslint-disable-line import/first
import StoreModule from './modules/store' // eslint-disable-line import/first
import RouterModule from './modules/router' // eslint-disable-line import/first
import ModalsModule from './modules/modals' // eslint-disable-line import/first
import EventsModule from './modules/events' // eslint-disable-line import/first
import GoogleAnalyticsModule from './modules/google-analytics' // eslint-disable-line import/first
import ErrorTrackingModule from './modules/error-tracking' // eslint-disable-line import/first
import TestsModule from './modules/_tests' // eslint-disable-line import/first
import HomeModule from './modules/home' // eslint-disable-line import/first
import UsersModule from './modules/users' // eslint-disable-line import/first
import DocumentsModule from './modules/documents' // eslint-disable-line import/first
import { appModule, getAppInstance } from './modules/app' // eslint-disable-line import/first


appModule.addModule(new EventBusModule())
appModule.addModule(new LocalStorageModule())
appModule.addModule(new LocalRouterModule())
appModule.addModule(new StoreModule())
appModule.addModule(new RouterModule())
appModule.addModule(new LocalizationModule())
appModule.addModule(new ModalsModule())
appModule.addModule(new EventsModule())
appModule.addModule(new TestsModule())
appModule.addModule(new ConfigModule())
appModule.addModule(new GoogleAnalyticsModule())
appModule.addModule(new ErrorTrackingModule())
appModule.addModule(new UsersModule())
appModule.addModule(new HomeModule())
appModule.addModule(new DocumentsModule())

appModule.preInstall().then(() => {
    appModule.mountApp()
})



// WEBPACK FOOTER //
// ./src/main.js